import Resource from './Resource.component';

export default Resource;
